import { css } from '@emotion/core'

export const hiddenCss = css`
  display: none;
`

// Use this for screen-reader only CSS
// Typically this is only needed for a block a text otherwise a standard aria-label would be used.
// https://github.com/twbs/bootstrap/blob/f61a0218b36d915db80dc23635a9078e98e2e3e0/scss/mixins/_visually-hidden.scss MIT license
export const visuallyHiddenCss = css`
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
`
